import React from 'react';

interface BrandPendulumMarkProps {
  className?: string;
  /** Render the artwork as an image so loading/status UI does not run physics animation. */
  animated?: boolean;
}

const BRAND_PENDULUM_MARK_SRC = `${process.env.PUBLIC_URL || ''}/brand-pendulum-mark.svg`;

export const BrandPendulumMark: React.FC<BrandPendulumMarkProps> = ({ className, animated = true }) => (
  <span className={className} aria-hidden="true">
    {animated ? (
      <object
        className="brand-mark__object"
        data={BRAND_PENDULUM_MARK_SRC}
        type="image/svg+xml"
        tabIndex={-1}
      >
        <img className="brand-mark__fallback" src={BRAND_PENDULUM_MARK_SRC} alt="" />
      </object>
    ) : (
      <img className="brand-mark__fallback" src={BRAND_PENDULUM_MARK_SRC} alt="" />
    )}
  </span>
);
